<template>
  <div class="activity-login">
    <div class="activity-login__wrap">
      <p class="activity-login__title">
        Login Activity
      </p>


      <template v-if="!isLoading && logActivityLoginList && logActivityLoginList.length > 0">
        <div class="activity-login__content">
          <div
            v-for="item in logActivityLoginList"
            :key="item.id"
            class="activity-login__item shadow-sm"
          >
            <div class="activity-login__item__left">
              <div>
                <img
                  v-if="item.device_type === 'mobile'"
                  :src="require('@/assets/icon/phone.svg')"
                  alt="device"
                >
                <img
                  v-else-if="item.device_type === 'web'"
                  :src="require('@/assets/icon/laptop.svg')"
                  alt="device"
                >
                <img
                  v-else
                  :src="require('@/assets/icon/unknown-device.svg')"
                  alt="device"
                >
              </div>
              <div class="activity-login__item__info">
                <p class="activity-login__item__title">
                  {{ item.registered_device || 'Unknown device' }}
                  {{ item.operating_system ? `(${item.operating_system})` : '(Unknown OS)' }}
                </p>
                <p class="activity-login__item__subtitle">
                  {{ $moment(item.login_time).format('D MMMM YYYY HH:mm:ss') }}
                </p>
                <button
                  v-if="item.status === 1"
                  class="activity-login__item__button btn"
                  @click="onClickLogout(item)"
                >
                  Logout
                </button>
              </div>
            </div>

            <div
              :class="{'green': item.status === 1}"
              class="activity-login__item__status"
            >
              <div/>
              <span>{{ item.status === 1 ? 'Active' : 'Inactive' }}</span>
            </div>
          </div>
        </div>


      </template>

      <template v-else-if="isLoading">
        <j-skeleton-log-activity-login />
      </template>

      <div v-else>
        <p>No Data</p>
      </div>

      <div class="activity-login__pagination">
        <div class="custom-pagination">
          <div
            :class="{'disabled': isDisabledPrevPage}"
            class="btn-previous"
            @click="onClickPrevPage"
          >
            <i class="fa fa-chevron-left"/>
          </div>
          <div
            :class="{'disabled': isDisabledNextPage}"
            class="btn-forward"
            @click="onClickNextPage"
          >
            <i class="fa fa-chevron-right"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jSkeletonLogActivityLogin from './jSkeletonLogActivityLogin';


export default {
  components: {
    jLoadingTable,
    jSkeletonLogActivityLogin,
  },

  data() {
    return {
      isLoading: false,
      logActivityLoginList: [],
      params: {
        user_company_id: '',
        page: 1,
        page_size: 10,
      },
    };
  },

  computed: {
    ...mapState('jStoreEmployee', ['employee_detail', 'user_detail']),

    userCompanyId() {
      return this.employee_detail && this.employee_detail.user_company_id
        ? this.employee_detail.user_company_id : null;
    },
    isDisabledPrevPage() {
      return this.params.page === 1;
    },
    isDisabledNextPage() {
      return this.logActivityLoginList.length < this.params.page_size;
    },
    isAdmin() {
      const role = localStorage.getItem('userRole');
      return Number(role) === 1;
    },
  },

  created() {
    this.getDataLog();
  },


  methods: {
    ...mapActions('jStoreLoginActivity', ['getLoginActivityList', 'forceLogout']),
    ...mapActions('jStoreNotificationScreen', ['toggleProblem']),


    async getDataLog() {
      this.isLoading = true;
      if (this.userCompanyId) {
        this.params.user_company_id = this.userCompanyId;

        const res = await this.getLoginActivityList(this.params);

        if (res && !res.error) {
          this.logActivityLoginList = res.data;
        }

        setTimeout(() => {
          this.isLoading = false;
        }, 300);
      }
    },

    onClickPrevPage() {
      if (!this.isDisabledPrevPage) {
        this.params.page = this.params.page - 1;

        this.getDataLog();
      }
    },

    onClickNextPage() {
      if (!this.isDisabledNextPage) {
        this.params.page = this.params.page + 1;

        this.getDataLog();
      }
    },

    async onClickLogout(log) {
      const params = {
        id: log.id,
        user_company_id: log.user_company_id,
      };

      const res = await this.forceLogout(params);
      if (!res.error) {
        this.getDataLog();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/user-employee/log-activity/jLogActivityLogin.vue